<template>
  <SelectSingleInput
    v-model="model"
    :items="OqcIqcItems"
    itemText="name"
    itemValue="value"
    :label="labelComputed"
    :disabled="disabledComputed"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { OqcIqcCd } from '@/enum'

export default {
  name: 'OqcIqcInput',

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0140')
      },
    },
    OqcIqcItems: {
      get() {
        // プルダウン選択肢をenumから生成
        return Object.values(OqcIqcCd).map((item) => {
          return { name: item + ' : ' + this.$t(`InspTiming.${item}`), value: item }
        })
      },
    },
    disabledComputed: {
      get() {
        return this.disabled || this.$store.getters.canOQCOnly
      },
    },
  },

  mounted() {
    if (!this.model) {
      if (this.$store.getters.canOQCOnly) {
        this.model = OqcIqcCd.OQC
      } else if (this.$store.getters.canIQC) {
        this.model = OqcIqcCd.IQC
      }
    }
  },
}
</script>
